<template>
  <v-container>
    <h3 class="page-title">邀約名單下載</h3>
    <v-row>
      <v-col cols="6" sm="3">
        <v-autocomplete
          v-model="selected.行政區"
          outlined
          :items="衛生所"
          label="負責衛生所"
          dense
          hide-details
          :disabled="!!this.$store.state.user.行政區"
        ></v-autocomplete>
      </v-col>
      <v-col cols="6" sm="3">
        <v-autocomplete
          v-model.number="selected.年度"
          :items="年度"
          label="年度"
          outlined
          dense
          hide-details
        ></v-autocomplete>
      </v-col>

      <v-col cols="6" sm="6" class="">
        <v-btn color="warning" @click="openNotify" v-if="isManager">
          推播名單
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-title>推播名單</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="py-1 label">推播方式：</v-col>
            <v-col class="col-auto py-1">
              <v-radio-group
                v-model="notifyTypes"
                row
                hide-details
                class="mt-0"
              >
                <v-radio value="line" label="Line" hide-details></v-radio>
                <v-radio value="sms" label="簡訊" hide-details></v-radio>
                <v-radio value="auto" label="Line+簡訊" hide-details></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">推播規則：</v-col>
            <v-col class="py-1">
              <v-radio-group v-model="op" row hide-details class="mt-0">
                <v-radio
                  class="py-0 my-0"
                  label="全部符合"
                  value="and"
                ></v-radio>
                <v-radio
                  class="py-0 my-0"
                  label="任一符合"
                  value="or"
                ></v-radio>
                <v-radio
                  class="py-0 my-0"
                  label="所有民眾"
                  value="all"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">篩檢項目：</v-col>
            <v-col
              v-for="(item, key) in inviteItems"
              class="col-auto my-0 py-1"
              :key="key"
            >
              <v-checkbox
                class="mt-0 pt-0"
                v-model="items"
                :value="key"
                :label="key"
                hide-details
                :disabled="op == 'all'"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">特殊身分：</v-col>
            <v-col
              v-for="key in identityOptions"
              class="col-auto my-0 py-1"
              :key="key"
            >
              <v-checkbox
                class="mt-0 pt-0"
                v-model="specialIdentities"
                :value="key"
                :label="key"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">名單來源：</v-col>
            <v-col class="col-auto py-1">
              <v-checkbox
                class="mt-0 pt-0"
                v-model="excludeSlowSign"
                label="排除慢簽"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">首篩條件：</v-col>
            <v-col
              v-for="key in [
                '成健首篩',
                '大腸首篩',
                '乳攝首篩',
                '乳攝三年未篩',
                '子抹首篩',
                '子抹兩年未篩',
              ]"
              class="col-auto my-0 py-1"
              :key="key"
            >
              <v-checkbox
                class="mt-0 pt-0"
                v-model="firstTime"
                :value="key"
                :label="key"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">地址關鍵字：</v-col>
            <v-col>
              <v-text-field
                label="關鍵字"
                v-model="address"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">年齡區間：</v-col>
            <v-col>
              <v-text-field
                label="大於歲數"
                v-model="moreThanAge"
                outlined
                dense
                hide-details
                class="d-inline-block"
                style="width: 100px"
              ></v-text-field>
              ~
              <v-text-field
                label="小於歲數"
                v-model="lessThanAge"
                outlined
                dense
                hide-details
                class="d-inline-block"
                style="width: 100px"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">身障類別：</v-col>
            <v-col>
              <v-checkbox
                v-for="item in disabilityTypeOptions"
                :key="item"
                v-model="disabilityTypes"
                :label="item"
                :value="item.split(' ')[0]"
                hide-details
                class="mt-0 pt-1"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">生日月份：</v-col>
            <v-col>
              <v-select
                v-model="birthMonth"
                :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                label="月份"
                outlined
                dense
                hide-details
                class="d-inline-block"
                style="width: 100px"
              ></v-select>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col cols="12" class="py-1 label">符合人數：</v-col>
            <v-col class="py-1">
              送出時由後端計算
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" class="py-1 label">推播內容：</v-col>
            <v-col class="py-1">
              <v-textarea
                v-model="content"
                hint="可用變數 {name}、{item}"
                outlined
                dense
                persistent-hint
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">推播時間：</v-col>
            <v-col cols="6">
              <v-text-field
                v-model="visibleTime"
                label="推播時間"
                outlined
                hint="格式必須為 YYYY-MM-DD HH:mm:ss"
                persistent-hint
                dense
                :rules="[
                  (v) =>
                    /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(v) ||
                    '格式必須為 YYYY-MM-DD HH:mm:ss',
                ]"
                placeholder="2025-01-01 13:00:05"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1 label">名單重算：</v-col>
            <v-col class="col-auto py-1">
              <v-checkbox
                class="mt-0 pt-0"
                v-model="forceRefresh"
                label="強制重算"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0 note-text">
              勾選「強制重算」時，下載名單與推播都會忽略快取，改以目前篩選條件即時重算名單，若未勾選則沿用每日快取名單，速度較快但可能不是即時資料。
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="downloadMatchList"
            >下載名單</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false">取消</v-btn>
          <v-btn color="primary" @click="send">送出</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { 行政區 } from "@/libs/const";
import dayjs from "dayjs";
import { 健檢項目 } from "@/libs/const";

const 年度 = dayjs().get("year") - 1911;
const all行政區 = {
  text: "全部",
  value: null,
};
export default {
  name: "Invite",
  data: () => ({
    健檢項目,
    selected: {
      行政區: null,
      年度,
    },
    identityOptions: ["獨老", "原住民", "慢簽"],
    specialIdentities: [],
    disabilityTypes: [],
    disabilityTypeOptions: [
      "第一類 (神經系統構造及精神、心智功能)",
      "第二類 (眼、耳及相關構造與感官功能及疼痛)",
      "第三類 (涉及聲音與言語構造及其功能)",
      "第四類 (循環、造血、免疫與呼吸系統構造及其功能)",
      "第五類 (消化、新陳代謝與內分泌系統相關構造及其功能)",
      "第六類 (泌尿與生殖系統相關構造及其功能)",
      "第七類 (神經、肌肉、骨骼之移動相關構造及其功能)",
      "第八類 (皮膚與相關構造及其功能)",
      "第九類 (特殊及罕見疾病)",
      "第十類 (其他)",
    ],
    notifyTypes: null,
    items: [],
    firstTime: [],
    dialog: false,
    op: "and",
    address: "",
    moreThanAge: null,
    lessThanAge: null,
    content:
      "{name}你好，今年可做篩檢項目為{item}，請至 https://p.tainan.gov.tw/1f09 預約服務。",
    birthMonth: null,
    visibleTime: null,
    excludeSlowSign: false,
    forceRefresh: true,
  }),
  computed: {
    isManager() {
      return ["管理者", "衛生局管理員", "衛生局", "衛生所管理者"].includes(
        this.$store.state.user.角色,
      );
    },
    衛生所() {
      let place = 行政區.map((v) => ({
        text: v + "衛生所",
        value: v,
      }));
      place.unshift(all行政區);
      return place;
    },
    年度() {
      let years = [年度 + 1];
      for (let n = 0; n <= 3; n++) {
        years.push(年度 - n);
      }
      return years;
    },
    inviteItems() {
      return {
        ...健檢項目,
        潛伏結核: {
          title: "潛伏結核感染篩檢",
        },
      };
    },
  },
  async created() {
    if (this.$store.state.user.行政區) {
      this.selected.行政區 = this.衛生所.find(
        (row) => row.value == this.$store.state.user.行政區,
      );
    }
  },
  methods: {
    getSelectedDistrict() {
      if (
        this.selected.行政區 instanceof Object &&
        !this.selected.行政區.value
      ) {
        return null;
      }
      return this.selected.行政區?.value || this.selected.行政區 || null;
    },
    getFilterPayload() {
      return {
        年度: this.selected.年度,
        行政區: this.getSelectedDistrict(),
        excludeSlowSign: this.excludeSlowSign,
        op: this.op,
        items: this.items,
        address: this.address,
        specialIdentities: this.specialIdentities,
        firstTime: this.firstTime,
        disabilityTypes: this.disabilityTypes,
        moreThanAge: this.moreThanAge,
        lessThanAge: this.lessThanAge,
        birthMonth: this.birthMonth,
        forceRefresh: this.forceRefresh,
      };
    },
    async downloadMatchList() {
      const 行政區 = this.getSelectedDistrict();
      if (!行政區 && !confirm("目前為全區下載，資料量可能較大，是否繼續？")) {
        return;
      }
      this.$vloading.show();
      try {
        const filters = this.getFilterPayload();
        const params = {
          年度: filters.年度,
          download: true,
          refresh: this.forceRefresh ? 1 : 0,
          excludeSlowSign: filters.excludeSlowSign ? 1 : 0,
          filters: JSON.stringify(filters),
        };
        if (filters.行政區) {
          params.行政區 = filters.行政區;
        }
        const response = await this.axios.get("/dashboard/person/inviteList", {
          params,
          responseType: "blob",
        });
        const blob = response.data;
        const filename = `${行政區 || "全區"}成健邀約名單.csv`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } finally {
        this.$vloading.hide();
      }
    },
    async send() {
      const filters = this.getFilterPayload();
      if (!this.notifyTypes) {
        this.$toast.error("請選擇推播方式！");
        return false;
      }
      if (
        !filters.行政區 &&
        !confirm("目前為全區推播，可能影響大量民眾，是否確認送出？")
      ) {
        return false;
      }
      if (confirm("確認依目前條件送出推播？")) {
        this.$vloading.show();
        let data = (
          await this.axios.post("/dashboard/person/notify", {
            filters,
            content: this.content,
            condition: {
              type: this.notifyTypes,
              op: this.op,
              items: this.items,
              address: this.address,
              specialIdentities: this.specialIdentities,
              firstTime: this.firstTime,
              disabilityTypes: this.disabilityTypes,
              moreThanAge: this.moreThanAge,
              lessThanAge: this.lessThanAge,
              birthMonth: this.birthMonth,
              excludeSlowSign: this.excludeSlowSign,
            },
            visibleTime: this.visibleTime,
          })
        ).data;
        alert(`符合推播條件 ${data.count} 位，已加入排程推播！`);
        this.$vloading.hide();
        this.dialog = false;
      }
    },
    async openNotify() {
      if (!this.selected.行政區) {
        this.$toast.warning("目前為全區模式，送出時會再次要求確認");
      }
      this.dialog = true;
    },
  },
  watch: {
    op(val) {
      if (val == "all") {
        this.items = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 16px;
  font-weight: bolder;
  margin-top: 10px;
}

.note-text {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
